export function dateDif(date1, date2, unit = "D") {
  if (!date1 || !date2) {
    return null;
  }

  const date1Truncated = truncateSeconds(date1);
  const date2Truncated = truncateSeconds(date2);

  const diffTime = Math.abs(date2Truncated - date1Truncated);

  switch (unit) {
    case "Y": {
      const yearsDiff = date2Truncated.getFullYear() - date1Truncated.getFullYear();
      const adjustedDate1 = new Date(date1Truncated).setFullYear(
        date1Truncated.getFullYear() + yearsDiff
      );
      return yearsDiff - (new Date(adjustedDate1) > date2Truncated ? 1 : 0);
    }
    case "M": {
      const yearsDiff = date2Truncated.getFullYear() - date1Truncated.getFullYear();
      const monthsDiff = date2Truncated.getMonth() - date1Truncated.getMonth();
      const totalMonths = yearsDiff * 12 + monthsDiff;

      const adjustedDate1 = new Date(date1Truncated);
      adjustedDate1.setMonth(date1Truncated.getMonth() + totalMonths);

      return totalMonths - (adjustedDate1 > date2Truncated ? 1 : 0);
    }
    case "H": {
      return Math.floor(diffTime / (1000 * 60 * 60));
    }
    case "m": {
      return Math.floor(diffTime / (1000 * 60));
    }
    default: // 'D'
      return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }
}

const truncateSeconds = (date) => {
  const dateObj = new Date(date);
  dateObj.setSeconds(0, 0);
  return dateObj;
};
